import { userBALService } from './user.bal';
const { config } = require('../config');

export const expenseBALService = {
    generateReport,
    getHistory,
    downloadReport
};

function generateReport(params) {
    return fetch(`${config.apiDDSUrl}/expenseReport/generate`, {
        body: JSON.stringify(params),
        method: 'PUT',
        headers: { ...userBALService.getAuthHeader(), 'Content-Type': 'application/json' }
    }).then(handleBinaryResponse);
}

function getHistory() {
    return fetch(`${config.apiDDSUrl}/expenseReport/history`, {
        body: JSON.stringify({}),
        method: 'PUT',
        headers: { ...userBALService.getAuthHeader(), 'Content-Type': 'application/json' }
    }).then(handleJsonResponse);
}

function downloadReport(fileName) {
    return fetch(`${config.apiDDSUrl}/expenseReport/download`, {
        body: JSON.stringify({ fileName: fileName }),
        method: 'PUT',
        headers: { ...userBALService.getAuthHeader(), 'Content-Type': 'application/json' }
    }).then(response => handleBinaryResponse(response, fileName));
}

function handleJsonResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok || (data && data.error_message)) {
            const error = (data && data.error_message) || (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}

function handleBinaryResponse(response, fallbackFileName) {
    if (!response.ok) {
        return response.text().then(text => {
            let error = response.statusText;
            try {
                const data = text && JSON.parse(text);
                error = (data && data.error_message) || (data && data.message) || response.statusText;
            } catch (e) {
                error = text || response.statusText;
            }
            return Promise.reject(error);
        });
    }

    const disposition = response.headers.get('Content-Disposition') || response.headers.get('content-disposition');
    let fileName = fallbackFileName || 'expense-report.xlsx';
    if (disposition) {
        const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
        if (utf8Match && utf8Match[1]) {
            fileName = decodeURIComponent(utf8Match[1]);
        } else {
            const match = disposition.match(/filename="?([^"]+)"?/i);
            if (match && match[1]) {
                fileName = match[1];
            }
        }
    }

    return response.blob().then(data => {
        return { data: data, fileName: fileName };
    });
}
